'use strict';

var Hosted = require('core/components/video/hosted');
var VideoModal = require('core/components/video/videoModal');
var videojs = require('video.js/dist/video.min.js');
function initPDPVideoModals() {
  $('body').on('click', '.product-detail .video-thumbnail, .product-detail .video-thumbnail-play', function (e) {
    e.preventDefault();
    var $modal = $('#videoModal');
    var $player = $modal.find('#pdp-video-player');
    // if $player exixt then remove it
    if ($player.length !== 0) {
      $player.remove();
    }
    var videoURL = $(this).closest('.slide').data('video-url');
    if (videoURL) {
      var params = {
        modal: true,
        inline: false,
        autoplay: true,
        mute: 0,
        controls: 1,
        loop: 0,
        hasThumb: false
      };
      var htmlString = "\n            <div class=\"video-container\" data-play-once=\"true\" data-play-when-fully-in-view=\"true\">\n                <div class=\"video-aspect-ratio aspect-ratio-9-16\">\n                    <video id=\"pdp-video-player\" class=\"video-player video-js\"\n                    data-video=\"hosted\"\n                    data-player-attr=".concat(JSON.stringify(params), "\n                    data-video-id=\"").concat(videoURL, "\">\n                    <source src=\"").concat(videoURL, "\" type=\"video/mp4\"/>\n                    </video>\n                </div>\n            </div>\n            ");
      $modal.find('.modal-body').html(htmlString);
      window.videojs = videojs;
      window.Players['pdp-video-player'] = new Hosted('pdp-video-player');
      window.Players['pdp-video-player'].setModal(VideoModal);
      window.Players['pdp-video-player'].launchModal();
      $modal.on('hidden.bs.modal', function () {
        window.Players['pdp-video-player'].pause();
      });
    }
  });
}
module.exports.initPDPVideoModals = initPDPVideoModals;